module.exports = __webpack_public_path__ + "img/untitled.502.919cbc3a.png";